import number from './number';

export default function deg(value, decimals = 0) {
  return value ? `${decimals ? number(value, decimals) : value}º` : '';
}
